var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _setup.isBigBrandBeds ? _c(_setup.BigBrandBedsReports) : _vm._e(),
      _vm._v(" "),
      _setup.isOdp ? _c(_setup.OdpReports) : _vm._e(),
      _vm._v(" "),
      _setup.isPrintGifts ? _c(_setup.PrintGiftsReports) : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }